import { Grid } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledColumn = styled(Grid.Column)`
 .ui.selection.dropdown {
  min-width: fit-content !important;
 }

 .ui.dropdown>.text {
    min-width: 100px;
    white-space: nowrap;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
 }
`

export const StyledMessage = styled.div<{$isSuccess: boolean}>`
   margin-bottom: 1em;
   padding: 0.8em 1em;
   border-radius: 4px;
   border: ${props => props.$isSuccess ? '2px solid rgb(40, 167, 69)' : '2px solid #ff0707ff'};
   display: flex;
   align-items: center;
   gap: 0.5em;
   font-size: 0.95em;
   background: ${props => props.$isSuccess ? 'rgb(212, 237, 218' : '#fff3cd'});
`